// LoadingScreen.jsx
import React from "react";

export default function LoadingScreen() {
  return (
    <div className="flex min-h-screen bg-white items-center justify-center">
      <div className="w-10 h-10 border-4 border-[#D62F50] border-t-transparent rounded-full animate-spin" />
    </div>
  );
}
